import { useState } from "react";
import paypal from "../../resources/icons/paypal.png";
import MessageModal from "../../components/shared/MessageModal";
import LoadingModal from "../../components/shared/LoadingModal";
import { checkout, various } from "../../Data/siteContent";

const OrderSummaryContent = ({
  cartItems,
  formData,
  shippingCost,
  total,
  isFormValid,
  handlePayment,
  isLoading,
  checkoutError,
  closeCheckoutError,
  isMobile,
}) => {
  const [termsAccepted, setTermsAccepted] = useState(false);
  const summaryClass = isMobile ? "order-summary-mobile" : "order-summary";
  const cartItemClass = isMobile ? "cart-item-checkout-mobile" : "cart-item-checkout";
  const shippingInfoClass = isMobile ? "shipping-included-mobile-info" : "shipping-included-info";
  const availableClass = isMobile ? "available-shipping-mobile" : "available-shipping";

  return (
    <>
      <div className={summaryClass}>
        <h2>{checkout.yourOrderTitle}</h2>
        {cartItems.length > 0 ? (
          cartItems.map((item, index) => (
            <div key={index} className={cartItemClass}>
              {isMobile ? (
                <div>
                  <strong>Product:</strong>
                  <div>
                    {item.name} - <span>{item.secondTitle}</span>
                  </div>
                </div>
              ) : (
                <>
                  <h3>{item.name}</h3>
                  {item.secondTitle}
                </>
              )}
              {item.image ? (
                <img src={item.image} alt={item.name} className="cart-item-image" />
              ) : (
                <p>{various.noImageAvailable}</p>
              )}
              <p>
                <strong>Price:</strong> {item.price}
              </p>
              {(item.quantity || 1) > 1 && (
                <p>
                  <strong>{various.quantityLabel}:</strong> {item.quantity}
                </p>
              )}
              <div className={availableClass}>{checkout.usuallyAvailable}</div>
            </div>
          ))
        ) : isMobile ? (
          <p className="p-cart-empty-message">{checkout.cartEmptyMessage}</p>
        ) : null}
        <p className={isMobile ? "total-text-mobile-checkout" : ""}>
          <strong>{checkout.shippingCostsLabel}</strong>{" "}
          {formData.country ? (
            `${Math.round(shippingCost)}€`
          ) : (
            <span className="shipping-rate-warning">{checkout.selectCountryWarning}</span>
          )}
        </p>
        <p className={isMobile ? "total-text-mobile-checkout" : ""}>
          <strong>{checkout.totalLabel}</strong> {Math.round(total)}€
          {!formData.country && ` ${checkout.totalPlusShipping}`}
        </p>
        <div>
          <div className={shippingInfoClass}>
            {checkout.shippingInfos}&nbsp;
            <a href="/terms-conditions?noloader" target="_blank" rel="noopener noreferrer">
              {checkout.termsConditionsMessageLink}
            </a>
            <br />
          </div>
        </div>
      </div>

      <div className="payment-options">
        <label className="terms-checkbox-label">
          <input type="checkbox" checked={termsAccepted} onChange={e => setTermsAccepted(e.target.checked)} />
          {checkout.termsCheckboxText}
          <a href="/terms-conditions?noloader" target="_blank" rel="noopener noreferrer">
            {checkout.termsCheckboxLink}
          </a>
        </label>
        {(cartItems.length === 0 || !isFormValid()) && <p className="fill-form-warning">{checkout.fillFormWarning}</p>}
        <button
          className="pay-paypal-button"
          type="button"
          onClick={handlePayment}
          disabled={cartItems.length === 0 || !isFormValid() || !termsAccepted}
        >
          <img src={paypal} alt="PayPal" className="paypal-icon" />
          {various.paypalCheckout}
        </button>
      </div>

      <MessageModal
        isVisible={!!checkoutError}
        title="Payment error"
        message={checkoutError}
        type="error"
        closeLabel={checkout.closeButton}
        onClose={closeCheckoutError}
      />
      <LoadingModal isVisible={isLoading} />
    </>
  );
};

export default OrderSummaryContent;
